'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _widgetActions = require('../actions/widget-actions');

var _practiceTransformers = require('../transformers/practice-transformers');

var _reviewsTransformers = require('../transformers/reviews-transformers');

var _specialistsTransformers = require('../transformers/specialists-transformers');

var _peerRecommendationsTransformers = require('../transformers/peer-recommendations-transformers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_WidgetState', {
	value: require('react').PropTypes.shape({
		selectedIndex: require('react').PropTypes.any.isRequired,
		minReviewRating: require('react').PropTypes.any.isRequired,
		practice: require('react').PropTypes.object,
		practiceReviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialistsReviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialistsPeerRecommendations: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialists: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
		layoutType: require('react').PropTypes.any,
		specialistsPeerRecommendationsCount: require('react').PropTypes.any,
		specialistsReviewsCount: require('react').PropTypes.any,
		specialistReviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		disableBanner: require('react').PropTypes.any,
		disableProfileImage: require('react').PropTypes.any,
		disableTabs: require('react').PropTypes.any,
		profileType: require('react').PropTypes.any
	})
});


var INITIAL_STATE = {
	selectedIndex: 0,
	peerRecommendations: [],
	specialistsReviews: [],
	specialists: [],
	layoutType: 'page',
	minReviewRating: 0
};
var mapReviewsToSpecialist = function mapReviewsToSpecialist() {
	var specialists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var reviews = arguments[1];
	return specialists.map(function (specialist) {
		if (reviews && reviews[0] && reviews[0].specialist && reviews[0].specialist.id === specialist.id) {
			return (0, _extends3.default)({}, specialist, {
				reviews: (0, _reviewsTransformers.transformProfileReviews)(reviews)
			});
		}
		return specialist;
	});
};
var mapPeerRecommendationsToSpecialist = function mapPeerRecommendationsToSpecialist() {
	var specialists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var peerRecommendations = arguments[1];
	return specialists.map(function (specialist) {
		if (peerRecommendations && peerRecommendations[0] && peerRecommendations[0].recommendee_id === specialist.id) {
			return (0, _extends3.default)({}, specialist, {
				peerRecommendations: (0, _peerRecommendationsTransformers.transformPeerRecommendations)(peerRecommendations)
			});
		}
		return specialist;
	});
};
var widget = exports.widget = function widget(state, action) {
	switch (action.type) {
		case _widgetActions.LOAD_PRACTICE + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				practice: (0, _practiceTransformers.transformPractice)(action.response.practice),
				specialists: (0, _specialistsTransformers.specialistsTransformer)(action.response.specialists)
			});
		case _widgetActions.LOAD_SPECIALIST + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialist: (0, _specialistsTransformers.transformSpecialist)(action.response.specialist)
			});
		case _widgetActions.GET_PRACTICE_REVIEWS + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				practiceReviews: (0, _reviewsTransformers.transformProfileReviews)(action.response.reviews)
			});
		case _widgetActions.GET_SPECIALISTS_REVIEWS + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistsReviews: (0, _reviewsTransformers.transformSpecialistsReviews)(action.response.reviews)
			});
		case _widgetActions.GET_SPECIALIST_REVIEWS + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistReviews: (0, _reviewsTransformers.transformProfileReviews)(action.response.reviews)
			});
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistsPeerRecommendations: (0, _peerRecommendationsTransformers.transformPeerRecommendations)(action.response.peer_recommendations)
			});
		case _widgetActions.GET_SPECIALISTS_REVIEWS_COUNT + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistsReviewsCount: parseInt(action.response.count || 0)
			});
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistsPeerRecommendationsCount: parseInt(action.response.count || 0)
			});
		case _widgetActions.GET_SPECIALIST_REVIEWS_FOR_PRACTICE + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialists: mapReviewsToSpecialist(state.specialists, action.response.reviews)
			});
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialists: mapPeerRecommendationsToSpecialist(state.specialists, action.response)
			});
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS + '_RECEIVED':
			return (0, _extends3.default)({}, state, {
				isLoading: false,
				specialistRecommendations: (0, _peerRecommendationsTransformers.transformPeerRecommendations)(action.response)
			});
		case _widgetActions.SET_LAYOUT_TYPE:
			return (0, _extends3.default)({}, state, {
				layoutType: action.layoutType
			});
		case _widgetActions.SET_PROFILE_TYPE:
			return (0, _extends3.default)({}, state, {
				profileType: action.profileType
			});
		case _widgetActions.DISABLE_BANNER:
			return (0, _extends3.default)({}, state, {
				disableBanner: action.disableBanner
			});
		case _widgetActions.DISABLE_PROFILE_IMAGE:
			return (0, _extends3.default)({}, state, {
				disableProfileImage: action.disableProfileImage
			});
		case _widgetActions.DISABLE_TABS:
			return (0, _extends3.default)({}, state, {
				disableTabs: action.disableTabs
			});
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE + '_REQUESTED':
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT + '_REQUESTED':
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS + '_REQUESTED':
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS + '_REQUESTED':
		case _widgetActions.GET_SPECIALIST_REVIEWS_FOR_PRACTICE + '_REQUESTED':
		case _widgetActions.GET_SPECIALISTS_REVIEWS_COUNT + '_REQUESTED':
		case _widgetActions.GET_SPECIALISTS_REVIEWS + '_REQUESTED':
		case _widgetActions.GET_SPECIALIST_REVIEWS + '_REQUESTED':
		case _widgetActions.GET_PRACTICE_REVIEWS + '_REQUESTED':
		case _widgetActions.LOAD_SPECIALIST + '_REQUESTED':
		case _widgetActions.LOAD_PRACTICE + '_REQUESTED':
			return (0, _extends3.default)({}, state, {
				isLoading: true
			});
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS_FOR_PRACTICE + '_FAILED':
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS_COUNT + '_FAILED':
		case _widgetActions.GET_SPECIALISTS_PEER_RECOMMENDATIONS + '_FAILED':
		case _widgetActions.GET_SPECIALIST_PEER_RECOMMENDATIONS + '_FAILED':
		case _widgetActions.GET_SPECIALIST_REVIEWS_FOR_PRACTICE + '_FAILED':
		case _widgetActions.GET_SPECIALISTS_REVIEWS_COUNT + '_FAILED':
		case _widgetActions.GET_SPECIALISTS_REVIEWS + '_FAILED':
		case _widgetActions.GET_SPECIALIST_REVIEWS + '_FAILED':
		case _widgetActions.GET_PRACTICE_REVIEWS + '_FAILED':
		case _widgetActions.LOAD_SPECIALIST + '_FAILED':
		case _widgetActions.LOAD_PRACTICE + '_FAILED':
			return (0, _extends3.default)({}, state, {
				isLoading: false
			});
		case _widgetActions.SET_MIN_REVIEW_RATING:
			return (0, _extends3.default)({}, state, {
				minReviewRating: action.minReviewRating
			});
		default:
			return state || INITIAL_STATE;
	}
};